/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Auto_LabelInputs */

const en_audio_recorder_auto_label = /** @type {(inputs: Audio_Recorder_Auto_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto`)
};

const fr_audio_recorder_auto_label = /** @type {(inputs: Audio_Recorder_Auto_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto`)
};

const de_audio_recorder_auto_label = /** @type {(inputs: Audio_Recorder_Auto_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto`)
};

const it_audio_recorder_auto_label = /** @type {(inputs: Audio_Recorder_Auto_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto`)
};

const ru_audio_recorder_auto_label = /** @type {(inputs: Audio_Recorder_Auto_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Авто`)
};

const es_audio_recorder_auto_label = /** @type {(inputs: Audio_Recorder_Auto_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto`)
};

const zh_cn2_audio_recorder_auto_label = /** @type {(inputs: Audio_Recorder_Auto_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`汽车`)
};

const ja_audio_recorder_auto_label = /** @type {(inputs: Audio_Recorder_Auto_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オート`)
};

const hi_audio_recorder_auto_label = /** @type {(inputs: Audio_Recorder_Auto_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑटो`)
};

const pt_pt2_audio_recorder_auto_label = /** @type {(inputs: Audio_Recorder_Auto_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto`)
};

/**
* | output |
* | --- |
* | "Auto" |
*
* @param {Audio_Recorder_Auto_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_auto_label = /** @type {((inputs?: Audio_Recorder_Auto_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Auto_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_recorder_auto_label(inputs)
	if (locale === "de") return de_audio_recorder_auto_label(inputs)
	if (locale === "it") return it_audio_recorder_auto_label(inputs)
	if (locale === "ru") return ru_audio_recorder_auto_label(inputs)
	if (locale === "es") return es_audio_recorder_auto_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_recorder_auto_label(inputs)
	if (locale === "ja") return ja_audio_recorder_auto_label(inputs)
	if (locale === "hi") return hi_audio_recorder_auto_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_recorder_auto_label(inputs)
	return en_audio_recorder_auto_label(inputs)
});